
import {
  fireStore,
  limit,
  orderBy,
  QueryDocumentSnapshot,
  QuerySnapshot,
  Song,
  SongDoc,
  startAfter
} from "@/includes/firebase/fireStore";
import { defineComponent } from "vue";
import SongItem from "@/components/Home/SongItem.vue";
import { SelfBuildingSquareSpinner } from "epic-spinners";
import { iconSecondary } from "@/directives/icon";

// @ is an alias to /src

export default defineComponent({
  name: "Home",
  components: {
    SongItem,
    SelfBuildingSquareSpinner: SelfBuildingSquareSpinner
  },
  directives:{
    'icon-secondary':iconSecondary
  },
  data() {
    return {
      songs: null as Song[] | null,
      lastVisible: null as QueryDocumentSnapshot<SongDoc> | null,
      pendingRequest: false,
      isEnd: false,
      limit: 10
    };
  },
  async mounted() {
    await this.getSongs();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll(e: Event) {
      const { scrollTop, offsetHeight } = document.documentElement;
      const { innerHeight } = window;
      const bottomOfWindow = Math.round(scrollTop) + innerHeight === offsetHeight;
      if (bottomOfWindow) {
        this.getSongs();
      }
    },
    async getSongs() {
      if (this.pendingRequest || this.isEnd) {
        return;
      }
      this.pendingRequest = true;
      let songsSnapshot: QuerySnapshot<SongDoc>;
      if (!this.lastVisible) {
        songsSnapshot = await fireStore.getDocs<SongDoc>(
          "songs",
          orderBy("modified_name"),
          limit(this.limit)
        );
      } else {
        songsSnapshot = await fireStore.getDocs<SongDoc>(
          "songs",
          orderBy("modified_name"),
          startAfter(this.lastVisible),
          limit(this.limit)
        );
      }
      console.log(songsSnapshot);
      const songs = songsSnapshot.docs.map(songDoc => {
        return { ...songDoc.data(), docId: songDoc.id };
      });
      const length = songsSnapshot.docs.length;
      this.lastVisible = songsSnapshot.docs[length - 1];
      this.songs ? (this.songs = [...this.songs, ...songs]) : (this.songs = songs);
      this.pendingRequest = false;
      if (songs.length === 0) {
        this.isEnd = true;
      }
    }
  }
});
